<div class="content-wrapper container-xxl p-0">
    <div class="content-body">
        <app-content-header [contentHeader]="contentHeader"></app-content-header>
        <core-card [actions]="[]">
            <div class="card-title w-100">
                <div [ngClass.xl]="'float-left'" [ngClass.md]="'float-left'" [ngClass.sm]="'mb-075'">
                    <input type="search" id="datatable-search-input" [placeholder]="'SEARCH' | translate"
                           class="form-control"
                           [(ngModel)]="searchKeyword" (ngModelChange)="templateDocumentList()"/>
                </div>
                <div class="float-right">
                    <div [ngClass.xl]="'d-inline-block mr-2'" [ngClass.md]="'d-inline-block mr-2'"
                         [ngClass.sm]="'d-none'">
                        <label class="d-flex align-items-center" *ngIf="config.selectLimitItems">{{"SHOW" | translate}}
                            <select class="form-control ml-075 pr-3" (change)="updateTableLimit($event)">
                                <option value="10">10</option>
                                <option value="25">25</option>
                                <option value="50">50</option>
                                <option value="100">100</option>
                            </select>
                        </label>
                    </div>
                    <a class="btn btn-outline-primary text-primary" routerLink="/dashboard/documents-form-template"
                       *ngIf="_authenticationService.hasCapability('create_document_template')">{{'ADD' | translate}}</a>
                </div>
                <div class="clearboth"></div>
            </div>

            <!-- desktop-->
            <div class="card-body px-0 pb-0" *ngIf="_utilService.isDesktop">
                <ngx-datatable class="bootstrap core-bootstrap" columnMode="force" [headerHeight]="config.headerHeight"
                               [scrollbarH]="config.scrollbarH"
                               [messages]="{emptyMessage: ('NO_DATA_TO_DISPLAY' | translate)}"
                               [rowHeight]="config.rowHeight" [limit]="tableLimit" [footerHeight]="config.footerHeight"
                               [rows]="filteredTemplate">
                    <ngx-datatable-column *ngFor="let col of config.columns" [name]="col.text" [prop]="col.value"
                                          [width]="col.width || null" [sortable]="col.sortable || false">>
                        <ng-template ngx-datatable-cell-template let-row="row">
                            <span>{{ row[col.value] }}</span>
                        </ng-template>
                    </ngx-datatable-column>
                    <ngx-datatable-column name="{{'ACTIONS' | translate}}" [sortable]="false">
                        <ng-template ngx-datatable-cell-template let-row="row">
                            <div>
                                <button [ngbTooltip]="'VIEW_TEMPLATE' | translate"
                                        (click)="_utilService.getFile(row.url)"
                                        class="bg-transparent text-secondary pr-1 border-0"
                                        *ngIf="_authenticationService.hasCapability('create_document_template')">
                                    <i [data-feather]="'file'" size="19"></i>
                                </button>
                                <a class="bg-transparent border-0 text-secondary pr-1"
                                   [routerLink]="'/dashboard/documents-form-template/'+row.id"
                                   *ngIf="_authenticationService.hasCapability('edit_document_template')">
                                    <i [data-feather]="'edit-2'" size="19"></i>
                                </a>
                                <button (click)="deleteTemplateDocument(row)"
                                        class="bg-transparent border-0 text-danger remove-item"
                                        *ngIf="_authenticationService.hasCapability('delete_document_template')">
                                    <i [data-feather]="'trash-2'" size="19"></i>
                                </button>
                            </div>
                        </ng-template>
                    </ngx-datatable-column>
                </ngx-datatable>
            </div>

            <!--mobile - tablet-->
            <div class="card-body px-0 pb-0" *ngIf="_utilService.isMobile || _utilService.isTablet">
                <ngx-datatable class="bootstrap core-bootstrap" columnMode="force" [headerHeight]="config.headerHeight"
                               [scrollbarH]="config.scrollbarH" [messages]="{emptyMessage: ('NO_DATA_TO_DISPLAY' | translate)}"
                               [rowHeight]="190" [limit]="tableLimit"
                               [footerHeight]="filteredTemplate && filteredTemplate.length > 10 ? config.footerHeight : null"
                               [rows]="filteredTemplate">
                    <ngx-datatable-column [name]="'NAME' | translate" prop="title" [sortable]="false">
                        <ng-template ngx-datatable-cell-template let-row="row">
                            <div class="row list-item-mobile">
                                <div class="col-12 text-truncate" [ngClass.md]="'pl-0'">
                                    <span>{{ row.title }}</span>
                                </div>
                                <div class="col-12" [ngClass.md]="'pl-0'">
                                    <span class="font-weight-bold">{{"ONBOARDING" | translate}}: </span>
                                    <span>{{ row.in_onboarding }}</span>
                                </div>
                                <div class="col-12" *ngIf="row.update_date" [ngClass.md]="'pl-0'">
                                    <span class="font-weight-bold">{{"UPDATE_DATE" | translate}}: </span>
                                    <span>  {{ row.update_date }}</span>
                                </div>
                                <div class="col-12" [ngClass.md]="'pl-0'">
                                    <span class="font-weight-bold">{{"SIGNATURE" | translate}}: </span>
                                    <span> {{ row.require_signature }}</span>
                                </div>
                                <div class="col-12" [ngClass.md]="'pl-0'">
                                    <span class="font-weight-bold">{{"INSERT.VIEW_DOCUMENT" | translate}}: </span>
                                    <span> {{ row.require_acception }}</span>
                                </div>
                                <div class="col-12 text-right" [ngClass.md]="'pr-2'">
                                    <button (click)="_utilService.getFile(row.url)"
                                            class="bg-transparent text-secondary pr-1 border-0"
                                            *ngIf="_authenticationService.hasCapability('create_document_template')">
                                        <i [data-feather]="'file'" size="19"></i>
                                    </button>
                                    <a class="bg-transparent border-0 text-secondary px-1"
                                       *ngIf="_authenticationService.hasCapability('edit_document_template')"
                                       [routerLink]="'/dashboard/documents-form-template/'+row.id">
                                        <i [data-feather]="'edit-2'" size="19"></i>
                                    </a>
                                    <button (click)="deleteTemplateDocument(row)"
                                            class="bg-transparent border-0 text-danger remove-item"
                                            *ngIf="_authenticationService.hasCapability('delete_document_template')">
                                        <i [data-feather]="'trash-2'" size="19"></i>
                                    </button>
                                </div>
                            </div>
                        </ng-template>
                    </ngx-datatable-column>
                </ngx-datatable>
            </div>
        </core-card>
    </div>
</div>